<div class="material-tooltip-html-container">
    <div *ngIf="content" [innerHTML]="content"></div>
</div>
